import React from 'react'
import RequestUpdateContext from '../context/RequestUpdateContext'
import PropTypes from 'prop-types'

function RequestUpdateProvider(props) {
    const {loadRequestUpdate, setState, filters} = props

    return (
        <RequestUpdateContext.Provider
            value={{
                reLoadRequestUpdate: loadRequestUpdate,
                filters,
                setState: setState
            }}
        >
            {props.children}
        </RequestUpdateContext.Provider>
    )
}

RequestUpdateProvider.propTypes = {
    loadShippingRules: PropTypes.func.isRequired
}

export default RequestUpdateProvider
